<template>
  <div class="selectionmarker" v-if="selected">
    <svg v-if="type == 'check'" xmlns="http://www.w3.org/2000/svg" v-bind:class="'svg-stroke--' + color" class="check" viewBox="0 0 6.46 5.08"><g id="Lag_2" data-name="Lag 2"><g id="Layer_1" data-name="Layer 1"><polyline class="cls-1" points="0.35 2.31 2.46 4.36 6.08 0.33"/></g></g></svg>
    <div class="dot" v-else v-bind:class="['bg--' + color]" ></div>
  </div>
</template>

<script>
export default {
  name: 'search',
  props: {
    type: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';
  @import '~@/components/sass/shared/helpers';

  .selectionmarker{
    align-items: center;
    display: flex; -js-display: flex;
    justify-content: center;
    font-size: 0;
    line-height: 0;
    height: 10px;
    width: 10px;
  }

  .dot{
    border-radius: 50%;
    display: block;
    flex: 0 0 auto;
    height: 5px;
    width: 5px;
  }

  .check{
    display: inline-block;
    flex: 0 0 auto;
    height: 8px;
    fill: none;
    stroke-miterlimit: 10;
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/shared/SelectionMarker.vue